var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"single-offer pt-10"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"offer-img img-full"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../../assets/images/admain.png"),"alt":""}})])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31a1f115","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dsmarket/singleofferadd.vue
// module id = null
// module chunks = 